import { Header2, Header3, Image, InlineText1, InlineText3, ModalWindow } from '@cian/ui-kit';

import { FC } from 'react';

import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

import { IContactModal } from './types';

import * as styles from './styles.css';

export const ContactModal: FC<IContactModal> = props => {
  const { operator, accessInfo, onClose, open } = props;

  if (!operator) {
    return null;
  }

  const { phone, companyName, logo } = operator;

  return (
    <ModalWindow escape outside height={246} open={open} width={448} onClose={onClose}>
      <div className={styles['root']}>
        <Header3>Контакты оператора коворкинга</Header3>
        <div className={styles['phone']}>
          <Header2>{formatPhoneNumber(phone)}</Header2>
        </div>
        <div className={styles['about']}>
          <div className={styles['operator']}>
            <InlineText3 color="gray60_100">Оператор коворкингов</InlineText3>
            <InlineText1 fontWeight="bold">{companyName}</InlineText1>
            <InlineText3>{accessInfo}</InlineText3>
          </div>
          <div className={styles['logo']}>
            <Image height={40} src={logo} width={40} />
          </div>
        </div>
      </div>
    </ModalWindow>
  );
};

ContactModal.displayName = 'ContactModal';
